export default __webpack_public_path__ + "static/pic06-7efad25fa39161707ea9bdee86b648ec.jpg";